<template>
    <el-dialog title='得分详情' :visible.sync="dialogVisible" :close-on-click-modal="false" :width="queryWidth(queryLayer)">
        <examine-tree ref="examine_tree"></examine-tree>
        <div class="box" v-if="detail.softwareScoreTree && detail.softwareScoreTree.length > 0">
            <div class="content-box">
                <div class="thead">
                    <div class="center" style="width: 20rem;">模块</div>
                    <div class="center" style="width: 10rem;">占比得分</div>
                    <div class="center" style="width: 10rem;">得分</div>
                    <div class="center" style="width: 20rem;" v-if="queryLayer == 1">提交时间</div>
                    <div class="center" style="width: 20rem;" v-if="queryLayer >= 2">考核步骤</div>
                    <div class="center" style="width: 20rem;" v-if="queryLayer >= 2">提交时间</div>
                    <div class="center" style="width: 20rem;" v-if="queryLayer == 3">考核任务</div>
                    <div class="center" style="width: 10rem;" v-if="queryLayer >= 2">步骤得分</div>
                </div>
                <div style="max-height: 66rem;overflow-y: auto;overflow-x: hidden;">
                    <div v-for="(item, index) in detail.softwareScoreTree && detail.softwareScoreTree"
                        style="border-bottom: 1px solid #e8ecef;"
                        :class="['single', { 'border-none': index == detail.softwareScoreTree.length - 1 }]" class="tbody-item"
                        :key="index">
                        <div class="flex-box">
                            <div class="center" style="width: 20rem;border-left: 1px solid #e8ecef;">
                                <el-tooltip effect="dark" :content="item.name" placement="top-start">
                                    <div class="text-overflow">{{ item.name }}</div>
                                </el-tooltip>
                            </div>
                            <div class="center" style="width: 10rem;border-left: 1px solid #e8ecef;">{{
                                item.scorePercent ==null?'/':item.scorePercent }}</div>
                            <div class="center" style="width: 10rem;border-left: 1px solid #e8ecef;">{{
                                item.scoreSum==null?'/':item.scoreSum}}</div>
                            <div class="center" v-if="queryLayer == 1"
                                style="width: 20rem;border-left: 1px solid #e8ecef;">{{ item.submitTime || '/' }}</div>
                        </div>
                        <div>
                            <div v-for="(el, key) in item.children && item.children"
                                style="min-height: 4.8rem;border-bottom: 1px solid #e8ecef;"
                                :class="{ 'border-none': key == item.children.length - 1 }" class="el-children" :key="key">
                                <div class="center" style="width: 20rem;border-left: 1px solid #e8ecef;">
                                    <el-tooltip effect="dark" :content="key + 1 + '.' + el.name" placement="top-start">
                                        <div class="text-overflow">{{ key + 1 + '.' + el.name }}</div>
                                    </el-tooltip>
                                </div>
                                <div class="center" style="width: 20rem;border-left: 1px solid #e8ecef;">{{
                                    item.submitTime||'/' }}</div>
                                <div>
                                    <div v-for="(e, k) in el.children && el.children"
                                        style="height: 4.8rem;display: flex;border-bottom: 1px solid #e8ecef;"
                                        :class="{ 'border-none': k == el.children.length - 1 }" :key="k">
                                        <div class="center" style="width: 20rem;border-left: 1px solid #e8ecef;">
                                            <el-tooltip effect="dark" :content="k + 1 + '.' + e.name" placement="top-start">
                                                <p class="center">{{ k + 1 + '.' + e.name }}</p>
                                            </el-tooltip>
                                        </div>
                                        <p class="center" style="width: 10rem;border-left: 1px solid #e8ecef;">{{
                                            e.score }}</p>
                                    </div>
                                    <div v-if="!el.children || el.children.length == 0"
                                        style="display: flex;height: 4.8rem;">
                                        <!-- <p class="center" style="width: 20rem;border-left: 1px solid #e8ecef;" ></p> -->
                                        <p class="center" style="width: 10rem;border-left: 1px solid #e8ecef;">
                                            {{ el.score }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <no-data style="height: 50rem;" v-else></no-data>
    </el-dialog>
</template>

<script>
import NoData from '../../../common/NoData.vue';
import ExamineTree from './ExamineTree.vue';
export default {
    components: { NoData, ExamineTree },
    data() {
        return {
            dialogVisible: false,
            detail: {},
        }
    },
    methods: {
        queryWidth(len) {
            if (len == 1) {
                return '70rem'
            } else if (len == 2) {
                return '100rem'
            } else if (len == 3) {
                return '120rem'
            }
        },
        /**打开得分详情弹窗 */
        openDetail(data) {
            if (!data || data.children.length == 0) {
                this.$msg({
                    showClose: true,
                    message: "暂无步骤展示",
                    type: "warning",
                });
                return;
            };
            let dialog = this.$refs.examine_tree;
            if (dialog) {
                dialog.dialogVisible = true;
                dialog.softwareName = data.name
                dialog.fullScore = this.detail.fullScore;
                dialog.stepFullScore = data.scoreSum;
                dialog.tableData = JSON.parse(JSON.stringify(data.children));
                dialog.tableData.forEach(item => {
                    if (!item.children || item.children.length == 0) {
                        item.children = [
                            {
                                score: item.score
                            }
                        ]
                    }
                })
            }
        }
    },
    computed: {
        /**判断有几层结构 */
        queryLayer() {
            if (!this.detail.softwareScoreTree) {
                return;
            }
            let children1 = this.detail.softwareScoreTree[0].children;
            if (!children1 || children1.length == 0) {
                return 1;
            } else {
                let children2 = children1[0].children;
                if (!children2 || children2.length == 0) {
                    return 2;
                }
            }
            return 3;
        }
    },
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__title {
    font-size: 16px;
    font-weight: 700;
}

.thead {
    height: 4.8rem;
    background-color: #ECF3FF;
    display: flex;
    align-items: center;
    color: #334681;
    font-weight: 700;
}

.tbody-item {
    min-height: 4.8rem;
    display: flex;
    color: #334681;
    font-weight: 700;

    .flex-box {
        display: flex;
    }
}

.single {
    background-color: rgba(236, 243, 255, 0.20);
}

.twin {
    background-color: #ECF3FF;
}

/deep/.el-dialog__body {
    padding: 0 3rem 5rem 3rem;
}

/deep/.el-dialog__header {
    padding: 3rem 5rem;
}

/deep/.el-dialog {
    border-radius: 16px;
}

/deep/.el-dialog__headerbtn {
    top: 1rem;
    right: 14px;
    color: #8590B3;
}

.content-box {
    border: 1px solid #e8ecef;
}

.blue-color {
    cursor: pointer;
    color: var(--blue) !important;
}

.el-children {
    display: flex;
}

.center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.border-none {
    border-bottom: none !important;
}

.text-overflow {
    width: 100%;
    text-align: center;
    padding: 0 2rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.box {
    display: flex;
    justify-content: center;
}
</style>